"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M20 19V3H4v16H2v2h20v-2zm-10 0V5h4v14z"
}), 'VerticalShades');